(function(){
  var root=document.querySelector('.pa-pdp'); if(!root) return;

  /* delivery estimate: 4 to 7 working days from today (Mon-Fri; public holidays not counted) */
  var eta=document.getElementById('lv-eta');
  if(eta){
    var addWd=function(n){ var d=new Date(), c=0; while(c<n){ d.setDate(d.getDate()+1); var w=d.getDay(); if(w!==0&&w!==6) c++; } return d; };
    var fmt=function(d){ try{ return d.toLocaleDateString('en-ZA',{weekday:'short',day:'numeric',month:'short'}).replace(',',''); }catch(e){ return d.toDateString().slice(0,10); } };
    eta.textContent='Order today and get it between '+fmt(addWd(4))+' and '+fmt(addWd(7));
  }

  /* gallery dots follow the swipe; arrows step one photo (wrap around); the demo video (slide 0) plays muted while visible */
  var track=document.getElementById('pa-track'), dotsWrap=document.getElementById('pa-gal-dots');
  var demo=document.getElementById('pa-demo');
  function playDemo(on){ if(!demo) return; try{ if(on){ var p=demo.play(); if(p&&p.catch) p.catch(function(){}); } else { demo.pause(); } }catch(e){} }
  if(track && dotsWrap){
    var dots=[].slice.call(dotsWrap.querySelectorAll('.pa-gal-dot')), raf=0, lockUntil=0;
    function setDot(i){ dots.forEach(function(d,k){ d.classList.toggle('is-on',k===i); }); if(demo && !(i===0)) playDemo(false); }
    function sync(){ var w=track.clientWidth||1, i=Math.max(0,Math.min(dots.length-1,Math.round(track.scrollLeft/w))); setDot(i); if(demo && i===0) playDemo(true); }
    function goTo(i){
      var w=track.clientWidth||1, x=i*w;
      lockUntil=Date.now()+800; setDot(i);
      track.scrollTo({left:x,behavior:'smooth'});
      /* safety net: if the smooth scroll did not run (reduced motion, background tab), jump there */
      setTimeout(function(){ if(Math.abs(track.scrollLeft-x)>2) track.scrollLeft=x; sync(); },700);
    }
    track.addEventListener('scroll',function(){
      if(raf||Date.now()<lockUntil) return;
      raf=requestAnimationFrame(function(){ raf=0; sync(); });
    },{passive:true});
    dots.forEach(function(d,i){ d.addEventListener('click',function(){ goTo(i); }); });
    function step(d){
      var w=track.clientWidth||1, n=track.children.length, i=Math.round(track.scrollLeft/w)+d;
      if(i<0) i=n-1; if(i>=n) i=0;
      goTo(i);
    }
    var pv=document.getElementById('pa-prev'), nx=document.getElementById('pa-next');
    if(pv) pv.addEventListener('click',function(){ step(-1); });
    if(nx) nx.addEventListener('click',function(){ step(1); });
  }
  if(demo){
    playDemo(true);
    document.addEventListener('visibilitychange',function(){ if(document.hidden) playDemo(false); });
    if('IntersectionObserver' in window){
      new IntersectionObserver(function(es){ es.forEach(function(e){ if(!e.isIntersecting) demo.pause(); else if(track && Math.round(track.scrollLeft/(track.clientWidth||1))===0) playDemo(true); }); },{threshold:0.4}).observe(demo);
    }
  }

  /* View full details */
  var more=document.getElementById('lv-more'), box=document.getElementById('lv-desc-more');
  if(more && box){
    more.addEventListener('click',function(){
      var open=more.getAttribute('aria-expanded')==='true';
      more.setAttribute('aria-expanded',open?'false':'true');
      box.hidden=open;
      more.querySelector('span').textContent=open?'View full details':'Show less';
    });
  }

  /* bundle cards write the quantity the form submits */
  var qty=document.getElementById('pa-qty'), cards=[].slice.call(document.querySelectorAll('#pa-bundles .bz-card'));
  function pick(c){
    cards.forEach(function(x){ var on=(x===c); x.classList.toggle('is-on',on); x.setAttribute('aria-pressed',on?'true':'false'); });
    if(qty) qty.value=c.getAttribute('data-qty');
  }
  cards.forEach(function(c){ c.addEventListener('click',function(){ pick(c); }); });
  var init=document.querySelector('#pa-bundles .bz-card.is-on'); if(init&&qty) qty.value=init.getAttribute('data-qty');

  /* animated accordions */
  [].forEach.call(document.querySelectorAll('.lv-acc'),function(d){
    var s=d.querySelector('summary'), b=d.querySelector('.lv-acc-body'), t=0;
    s.addEventListener('click',function(e){
      e.preventDefault(); clearTimeout(t);
      if(d.open){
        b.style.height=b.scrollHeight+'px'; void b.offsetHeight; b.style.height='0px';
        d.classList.remove('is-open');
        t=setTimeout(function(){ d.open=false; },290);
      }else{
        d.open=true; d.classList.add('is-open');
        b.style.height='0px'; void b.offsetHeight; b.style.height=b.scrollHeight+'px';
        t=setTimeout(function(){ b.style.height='auto'; },300);
      }
    });
  });

  /* rating row smooth-scrolls to reviews */
  var rate=document.getElementById('ag-rate'), rv=document.getElementById('reviews');
  if(rate&&rv) rate.addEventListener('click',function(e){ e.preventDefault(); rv.scrollIntoView({behavior:'smooth',block:'start'}); });
})();